import { Box, Grid, useTheme, useMediaQuery, Divider } from "@mui/material";
import { useEffect, useState } from "react";

export default function ShowItem({ open, imagesList, setOpenSlide }) {
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.only('xs'));
  const sm = useMediaQuery(theme.breakpoints.only('sm'));

  const [counter, setCounter] = useState(0);
  const [index, setIndex] = useState(0);
  const [start, setStart] = useState(false);

  const counterImg = 5;

  useEffect(() => {
    if (open && imagesList.length > 0) {
      const item = imagesList[0];
      if (item.mediatype === 'video') {
        var video = document.createElement('video');
        video.src = item.videourl;
        video.preload = 'metadata';
      
        video.onloadedmetadata = function() {
          var duration = video.duration;
          setIndex(0);
          setCounter(duration);
          setStart(true);
        }
      } else {
        setIndex(0);
        setCounter(counterImg);
        setStart(true);
      }
    }
  }, [open])

  useEffect(() => {
    if (start) {
      if (counter > 0) {
        setTimeout(() => {
          setCounter(counter - 1);
        }, 1000)
      } else {
        let newindex = index + 1;
        if (newindex > imagesList.length - 1) {
          newindex = 0;
        }
        
        const item = imagesList[newindex];
        if (item.mediatype === 'video') {
          var video = document.createElement('video');
          video.src = item.videourl;
          video.preload = 'metadata';
        
          video.onloadedmetadata = function() {
            var duration = video.duration;
            setIndex(newindex);
            setCounter(duration);
          }
        } else {
          setIndex(newindex);
          setCounter(counterImg);
        }
      }
    }
  }, [start, counter])

  return (
    <div className="main" onClick={() => setOpenSlide(false)}>
      <Grid container sx={{ height: '100%', width: '100%' }}>
        <Grid item xs={12} sm={12} md={6}>
          {imagesList.map((m, i) => (
            <Box key={i} sx={{ height: '100%', display: index === i ? 'flex' : 'none', background: 'black' }}>
              {m.mediatype === 'video' ? (
                <video autoPlay muted loop
                  style={{ width: '100%', height: '100vh' }}
                >
                  <source src={m.videourl} />
                </video>
              ) : (
                <img key={i} src={m.imgurl} style={{ width: '100%', height: '100vh' }} />
              )}
            </Box>
          ))}
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Box sx={{ 
            height: '100%',
            width: '100%',
            backgroundImage: 'url("/images/bg-queue.png")',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
          }}>
            <Box sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center'
            }}>
              <img src="/images/bg-queue2.svg" style={{ width: '100%', height: 'auto', maxHeight: 400 }} />
            </Box>

            <Box className="show-tv">
              <Box sx={{ width: '100%', textAlign: 'center', color: '#738670', py: 3, marginBottom: xs || sm ? 18 : 0 }}>
                <h1>พร้อมเสิร์ฟ</h1>
                <p className="p-font">SERVED</p>
                
                <Box sx={{ minHeight: 83 }}></Box>

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 2.5 }}>
                  <Divider sx={{ background: '#9ABB91', width: '30%', borderBottomWidth: 2, mr: 2 }} />
                  <img src="/images/color.svg" style={{ width: 'auto', height: 30 }} />
                  <Divider sx={{ background: '#9ABB91', width: '30%', borderBottomWidth: 2, ml: 2 }} />
                </Box>

                <h1>กำลังจัดเตรียม</h1>
                <p className="p-font">PREPARING</p>
                <p>จำนวน - คิว</p>
                <Box sx={{ minHeight: 200 }}>
                  
                </Box>
              </Box>

              <Box sx={{ 
                position: 'absolute',
                bottom: 0,
                left: 0,
                display: 'flex',
                width: '100%',
              }}>
                <Box sx={{ width: '50%', background: '#5F966C', color: 'white', py: 1, px: 2 }}>
                  <h3>Grab Food</h3>
                  <h1 className="tv-queue">{'-'}</h1>
                </Box>
                <Box sx={{ width: '50%', background: '#7BBA81', color: 'white', py: 1, px: 2 }}>
                  <h3>Robinhood</h3>
                  <h1 className="tv-queue">{'-'}</h1>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}